import PropTypes from "prop-types";

import Tooltip from "@mui/material/Tooltip";

import SoftBox from "components/SoftBox";
import SoftAvatar from "components/SoftAvatar";
import DefaultUserAvatar from "layouts/pages/account/components/Header/components/DefaultUserAvatar";

function UsersCell({ users = [] }) {
  const uniqueUsers = users.reduce((acc, user) => {
    const userKey = user.auth0_id || user.id || user.email_address || user.email;

    if (!acc.some((u) => (u.auth0_id || u.id || u.email_address || u.email) === userKey)) {
      acc.push(user);
    }
    return acc;
  }, []);

  const getUserLabel = (user) => {
    const fullName = `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim();
    return fullName || user?.email_address || user?.email || "";
  };

  const renderUserAvatar = (user, index) => {
    const userKey = user.auth0_id || user.id || user.email_address || user.email || index;
    const tooltipTitle = getUserLabel(user);

    return (
      <SoftBox
        key={`${userKey}_${index}`}
        sx={{
          ml: index === 0 ? 0 : -1.25,
          display: "flex",
          alignItems: "center",
          position: "relative",
          "&:hover, &:focus-within": {
            zIndex: 10
          }
        }}
      >
        {user?.image && user.image.trim() ? (
          <Tooltip title={tooltipTitle} placement="bottom">
            <SoftAvatar
              src={user.image}
              alt={tooltipTitle}
              size="xs"
              sx={({ borders: { borderWidth }, palette: { white } }) => ({
                border: `${borderWidth[2]} solid ${white.main}`,
                cursor: "pointer"
              })}
            />
          </Tooltip>
        ) : (
          <DefaultUserAvatar
            firstName={user?.first_name}
            lastName={user?.last_name}
            email={user?.email_address || user?.email}
            cursor="pointer"
            size="xs"
            placement="bottom"
            sx={({ borders: { borderWidth }, palette: { white } }) => ({
              border: `${borderWidth[2]} solid ${white.main}`,
              cursor: "pointer"
            })}
          />
        )}
      </SoftBox>
    );
  };

  if (uniqueUsers?.length > 5) {
    return (
      <SoftBox display="flex" alignItems="center" px={0}>
        {uniqueUsers?.slice(0, 5).map((user, index) => renderUserAvatar(user, index))}
      </SoftBox>
    );
  }

  return (
    <SoftBox display="flex" alignItems="center" px={0}>
      {uniqueUsers?.map((user, index) => renderUserAvatar(user, index))}
    </SoftBox>
  );
}

UsersCell.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
    })
  ),
};

export default UsersCell;
